// Module
var code = "<select ng-model=\"vm.model\" ng-options=\"option for option in vm.options\" data-placeholder=\"{{'general.filters.add' | translate}}\"> <option value=\"\">{{'general.filters.add' | translate}}</option> </select> ";
// Exports
module.exports = code;